module.exports = __webpack_public_path__ + "img/SKMJ_map2.53bafb5d.jpg";